import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css"; // Import CSS file

import App from "./App";
// import CookieConsent from "react-cookie-consent";
import { BrowserRouter } from "react-router-dom";
import CookieUI from "./CookieUI/CookieUI";

createRoot(document.getElementById("root")).render(
  <BrowserRouter>
    <StrictMode>
      
      <CookieUI />

      <App />
    </StrictMode>
  </BrowserRouter>
);
